import * as ActionTypes from './actionTypes';

export default function addHistoryRecord(id, recordType, operation) {
  return {
    type: ActionTypes.HISTORY_ADD_RECORD,
    payload: {
      id,
      recordType,
      operation,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/history.js